import { Alert, Snackbar } from "@mui/material";
import { IMessage } from "../../models";

export interface IAlert {
  message: IMessage;
  onClose: () => void;
}

export default ({ message, onClose }: IAlert) => {
  if (message?.message) {
    return (
      // <Stack sx={{ width: "100%", mt: 2, mb: 2 }} spacing={2}>
      <Snackbar
        open={true}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={6000}
        onClose={onClose}
      >
        <Alert
          severity={message?.type ? message?.type : "info"}
          onClose={onClose}
        >
          {message?.message}
        </Alert>
      </Snackbar>
      // </Stack>
    );
  } else {
    return null;
  }
};
